import React from 'react'
import { Modal } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { PlatformConnectionInner } from 'Features/platformConnectionModal/PlatformConnectionInner'
import { useLocation } from 'react-router-dom'

type PlatformConnectionModalProps = {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
}

const routesCanShowModal = ['/', '/domain-management']

export const PlatformConnectionModal = ({ isOpen, onOpenChange }: PlatformConnectionModalProps) => {
  const location = useLocation()
  const { owner } = useUserStore()
  const { t } = useTranslation('domainManagement')

  const canShowModal = () =>
    owner && routesCanShowModal.some((route) => location.pathname === route)

  return (
    <Modal
      id={'platform-connection-modal'}
      title={t('platformConnectionModal.title')}
      isOpen={isOpen && canShowModal()}
      onOpenChange={onOpenChange}
      onCloseClick={() => {}}
    >
      <PlatformConnectionInner onOpenChange={onOpenChange} />
    </Modal>
  )
}
